import { Group } from "../../group";
import { AvatarText } from "./Avatar";
import { Box } from "../../box";
import { Children, forwardRef } from "react";
import { augmentElement, cssModule, isNil, mergeClasses, mergeProps, normalizeSize } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { Tooltip, TooltipTrigger } from "../../tooltip";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "div";

function RemainingAvatars({
  avatars,
  size,
  ...rest
}) {
  return /*#__PURE__*/_jsxs(TooltipTrigger, {
    children: [/*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
        className: mergeClasses("o-ui-avatar-group-remainings", cssModule("o-ui-avatar", normalizeSize(size)))
      }),
      children: /*#__PURE__*/_jsx(AvatarText, {
        size: size,
        children: `+${avatars.length}`
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      children: /*#__PURE__*/_jsx("ul", {
        className: "o-ui-avatar-group-remainings-list",
        children: avatars.filter(x => {
          var _x$props;

          return !isNil(x === null || x === void 0 ? void 0 : (_x$props = x.props) === null || _x$props === void 0 ? void 0 : _x$props.name);
        }).map(x => {
          var _x$props2;

          const name = x === null || x === void 0 ? void 0 : (_x$props2 = x.props) === null || _x$props2 === void 0 ? void 0 : _x$props2.name;
          return /*#__PURE__*/_jsxs("li", {
            className: "o-ui-avatar-group-remainings-list-item",
            children: [augmentElement(x, {
              className: "o-ui-avatar-group-remainings-list-item-avatar",
              size: "sm"
            }), /*#__PURE__*/_jsx("span", {
              children: name
            })]
          }, name);
        })
      })
    })]
  });
}

const AvailableSlots = 4;
export function InnerAvatarGroup({
  size,
  as = DefaultElement,
  children,
  wrap = true,
  forwardedRef,
  ...rest
}) {
  const sizeValue = useResponsiveValue(size);
  const wrapValue = useResponsiveValue(wrap);
  const avatars = Children.toArray(children);
  const isExceeding = avatars.length > AvailableSlots;
  const shownAvatars = isExceeding ? avatars.slice(0, AvailableSlots - 1) : avatars;
  const remainingAvatars = isExceeding ? avatars.slice(AvailableSlots - 1) : null;
  const avatarsMarkup = shownAvatars.map(x => {
    var _x$props3;

    const name = x === null || x === void 0 ? void 0 : (_x$props3 = x.props) === null || _x$props3 === void 0 ? void 0 : _x$props3.name;
    return /*#__PURE__*/_jsxs(TooltipTrigger, {
      children: [augmentElement(x, {
        size: sizeValue
      }), /*#__PURE__*/_jsx(Tooltip, {
        children: name
      })]
    }, name);
  });

  const remainingAvatarsMarkup = remainingAvatars && /*#__PURE__*/_jsx(RemainingAvatars, {
    avatars: remainingAvatars,
    size: sizeValue
  });

  return /*#__PURE__*/_jsxs(Group, { ...mergeProps(rest, {
      as,
      className: "o-ui-avatar-group",
      gap: 1,
      orientation: "horizontal",
      ref: forwardedRef,
      wrap: wrapValue
    }),
    children: [avatarsMarkup, remainingAvatarsMarkup]
  });
}
InnerAvatarGroup.defaultElement = DefaultElement;
export const AvatarGroup = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerAvatarGroup, { ...props,
  forwardedRef: ref
}));